import { type ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";

// https://tabler.io/icons/icon/adjustments-horizontal
const AdjustmentsHorizontalIcon = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) => {
  const defaultClassnames =
    "icon icon-tabler icon-tabler-adjustments-horizontal h-2.5 w-2.5";

  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={twMerge(defaultClassnames, className)}
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <circle cx="14" cy="6" r="2"></circle>
        <line x1="4" y1="6" x2="12" y2="6"></line>
        <line x1="16" y1="6" x2="20" y2="6"></line>
        <circle cx="8" cy="12" r="2"></circle>
        <line x1="4" y1="12" x2="6" y2="12"></line>
        <line x1="10" y1="12" x2="20" y2="12"></line>
        <circle cx="17" cy="18" r="2"></circle>
        <line x1="4" y1="18" x2="15" y2="18"></line>
        <line x1="19" y1="18" x2="20" y2="18"></line>
      </svg>
    </div>
  );
};

export default AdjustmentsHorizontalIcon;
